import { Action } from 'redux';

import { ISelectFilterDefinitionOption } from '~src/spacesPlatform/services/FilterPanelService';

import { isMaxSiteRoleCountsForServerUserSpaceUpdateAction } from '../actions/MaxSiteRoleForServerUserSpaceActions';


export function maxSiteRoleCountsForServerUsersSpaceReducer(
  previousState: ISelectFilterDefinitionOption<string>[] = null,
  action: Action = null
): ISelectFilterDefinitionOption<string>[] {
  if (isMaxSiteRoleCountsForServerUserSpaceUpdateAction(action) && action?.maxSiteRoleCounts) {
    return action.maxSiteRoleCounts;
  }
  return previousState;
}

